import React from 'react';
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
} from 'react-router-dom';
import Header from './components/Header';
import Hero from './components/Hero';
import Content from './components/Content';
import CTA from './components/CTA';
import Features from './components/Features';
import Partners from './components/Partners';
import Footer from './components/Footer';
import CTAFooter from './components/CTAFooter';
import UserMigrationTeamsSplash from './components/UserMigrationTeamsSplash';
// import ResetPassword from './components/ResetPassword';
import './styles/HomePage.css';
// import RequestForm from './components/RequestForm';
import MaintenancePage from './components/MaintancePage';
const App: React.FC = () => {
  const requestAccountMessageStr = (
    <>
      <strong>New Account Requests Temporarily Paused</strong>
      <br /><br />
      We are migrating to a new standalone application to ensure Athena remains trusted and secure for the Athena community. While we complete this transition, new account requests are temporarily on hold.
      <br /><br />
      We're excited to welcome new users once the migration is complete! In the meantime, please feel free to reach out to me directly at{' '}
      <a href="mailto:rbasford@npsfoundation.org">rbasford@npsfoundation.org</a> with any questions.
      <br /><br />
      Thank you for your patience and understanding.
    </>
  );

  const migrateAccountMessageStr = (
    <>
      <strong>Account Migrations Are Temporarily Paused</strong>
      <br /><br />
      We are migrating to a new standalone application to ensure Athena remains trusted and secure for the Athena community. While we complete this transition, account migrations are temporarily paused.
      <br /><br />
      We're excited to welcome you once the Athena application is complete! In the meantime, please feel free to reach out to me directly at{' '}
      <a href="mailto:rbasford@npsfoundation.org">rbasford@npsfoundation.org</a> with any questions.
      <br /><br />
      Thank you for your patience and understanding.
    </>
  );
  return (
    <Router>
      <ConditionalHeaderAndFooter>
        <Routes>
          <Route
            path='/'
            element={
              <>
                <Hero />
                <Content />
                <Features />
                <CTA />
                <Partners />
              </>
            }
          />
          <Route
            path='/request-account'
            element={<MaintenancePage messageStr={requestAccountMessageStr} />}
          />
          <Route
            path='/user-migration-teams'
            element={<UserMigrationTeamsSplash />}
          />
          <Route
            path='/migrate-account'
            element={<MaintenancePage messageStr={migrateAccountMessageStr} />}
          />
        </Routes>
      </ConditionalHeaderAndFooter>
    </Router>
  );
};

const ConditionalHeaderAndFooter: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const location = useLocation();
  const showHeaderAndFooter =
    location.pathname !== '/request-account' &&
    location.pathname !== '/user-migration-teams' &&
    location.pathname !== '/migrate-account';

  return (
    <>
      {showHeaderAndFooter && <Header />}
      <main>{children}</main>
      {showHeaderAndFooter && <CTAFooter />}
      {showHeaderAndFooter && <Footer />}
    </>
  );
};

export default App;
